import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Grid from '@material-ui/core/Grid'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { ReactComponent as Logo } from '../assets/u2i.svg'

const useStyles = makeStyles(theme => ({
  app: {
    height: '100%',
  },
  mainHeader: {
    flexGrow: 1,
  },
  link: {
    color: '#ffffff',
    textDecoration: 'none',
  },
  bar: {
    backgroundColor: '',
  },
  logo: {
    height: 35,
  },
  content: {
    height: 'calc(100vh - 64px)',
  },
}))

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const classes = useStyles()

  return (
    <div className={classes.app}>
      <AppBar position="static">
        <Toolbar>
          <div className={classes.mainHeader}>
            <Link to="/" className={classes.link}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <Typography variant="h5">EstiTool</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body1"><i>by</i></Typography>
                </Grid>
                <Grid item>
                  <Logo className={classes.logo} />
                </Grid>
              </Grid>
            </Link>
          </div>
        </Toolbar>
      </AppBar>
      <Grid container justifyContent="center" className={classes.content}>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </div>
  )
}

export default Layout
